var ContainerFocusHandler = /** @class */ (function () {
    function ContainerFocusHandler(getItemsCount, setFocusAt) {
        var _this = this;
        this.getItemsCount = getItemsCount;
        this.setFocusAt = setFocusAt;
        this.focusedIndex = 0;
        this.noItems = function () { return _this.getItemsCount() === 0; };
    }
    ContainerFocusHandler.prototype.constrainFocusedIndex = function () {
        if (this.focusedIndex < 0) {
            this.focusedIndex = 0;
        }
        var itemsCount = this.getItemsCount();
        if (this.focusedIndex >= itemsCount) {
            this.focusedIndex = itemsCount - 1;
        }
    };
    ContainerFocusHandler.prototype.getFocusedIndex = function () {
        return this.focusedIndex;
    };
    ContainerFocusHandler.prototype.syncFocusedIndex = function (withCurrentIndex) {
        this.focusedIndex = withCurrentIndex;
    };
    ContainerFocusHandler.prototype.movePrevious = function () {
        if (this.noItems()) {
            return;
        }
        this.focusedIndex -= 1;
        this.constrainFocusedIndex();
        this.setFocusAt(this.focusedIndex);
    };
    ContainerFocusHandler.prototype.moveNext = function () {
        if (this.noItems()) {
            return;
        }
        this.focusedIndex += 1;
        this.constrainFocusedIndex();
        this.setFocusAt(this.focusedIndex);
    };
    ContainerFocusHandler.prototype.moveFirst = function () {
        if (this.noItems()) {
            return;
        }
        this.focusedIndex = 0;
        this.setFocusAt(this.focusedIndex);
    };
    ContainerFocusHandler.prototype.moveLast = function () {
        if (this.noItems()) {
            return;
        }
        this.focusedIndex = this.getItemsCount() - 1;
        this.setFocusAt(this.focusedIndex);
    };
    return ContainerFocusHandler;
}());
export { ContainerFocusHandler };
